import { useLocation } from "react-router";

import { trpc } from "@/lib/trpc";
import { getReleaseAccessRedirectPath } from "@/lib/release-access-routing";

export const useReleaseAccessGate = (input: { enabled: boolean; accessRequired: boolean }) => {
  const location = useLocation();
  const statusQuery = trpc.releaseAccess.status.useQuery(undefined, {
    enabled: input.enabled,
    staleTime: 30_000,
  });

  return {
    isPending: input.enabled && statusQuery.isPending,
    redirectTo: getReleaseAccessRedirectPath({
      accessRequired: input.accessRequired,
      allowed: statusQuery.data?.allowed,
      currentPath: location.pathname,
    }),
  };
};
